export default {
  cnCode: "Code NC",
  factorValue: "Facteur d'émission",
  unit: "Unité",
  coefficient: "Coefficient de procédé",
  description: "Description",
  createdAt: "Créé le",
  updatedAt: "Mis à jour le",
  action: "Action",
  error: "Erreur",
  search: "Rechercher",
  add: "Ajouter un facteur",
  edit: "Modifier",
  template: "Modèle",
  csvTemplate: "Modèle CSV",
  xlsxTemplate: "Modèle XLSX",
  deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce facteur ?",
  deleteConfirmBatch: "Êtes-vous sûr de vouloir supprimer ces facteurs ?",
  import: "Importer des facteurs",
  export: "Exporter des facteurs",
  close: "Fermer",
  reset: "Réimporter",
  resetConfirm: "Êtes-vous sûr de vouloir réimporter ?",
  ok: "OK",
  clearInvalid: "Effacer les données non valides",
  showErrorRows: "Afficher les données erronées",
  hideErrorRows: "Masquer les données erronées",
  placeholder: {
    cnCode: "Saisir le code NC (ex. '24')",
    factorValue: "Saisir le facteur d'émission",
    coefficient: "Saisir le coefficient de procédé (0-1)",
    description:
      "Saisir la description (ex. 'Utilisé pour la production d'acier à faibles émissions')",
    unit: "Sélectionner l'unité",
  },
  cnCodeRequired: "Veuillez saisir le code NC",
  cnCodeMaxLength: "Le code NC ne doit pas dépasser 20 caractères",
  cnCodeFormat: "Le code NC ne peut contenir que des lettres, chiffres et tirets bas",
  cnCodeExample: "Exemple : Code NC acier '24', Facteur d'émission 1,5, Coefficient de procédé 0,8",
  factorValueRequired: "Veuillez saisir le facteur d'émission",
  factorValueMin: "Le facteur d'émission doit être supérieur à 0",
  factorValueUnit: "L'unité est kg CO2e/kg, convertir le ciment dans cette unité",
  coefficientRequired: "Veuillez saisir le coefficient de procédé",
  coefficientRange: "Le coefficient de procédé doit être compris entre 0 et 1",
  descriptionMaxLength: "La description ne doit pas dépasser 255 caractères",
  fetchError: "Échec de la récupération des facteurs",
  addSuccess: "Facteur ajouté avec succès",
  addError: "Échec de l'ajout du facteur",
  editSuccess: "Facteur mis à jour avec succès",
  editError: "Échec de la mise à jour du facteur",
  deleteSuccess: "Facteur supprimé avec succès",
  deleteError: "Échec de la suppression du facteur",
  exportSuccess: "Exportation réussie",
  exportError: "Échec de l'exportation des facteurs",
  uploadFormatError: "Seuls les fichiers CSV ou XLSX sont pris en charge",
  headerInvalid:
    "En-tête de fichier invalide, attendu : cn_code,factor_value,coefficient,description",
  headerSkipped: "Ligne d'en-tête ignorée",
  importLimitExceeded: "Les données importées dépassent la limite (max {max} lignes valides)",
  noValidData: "Aucune donnée de facteur valide",
  parseError: "Échec de l'analyse du fichier",
  importError: "Échec de l'importation des facteurs",
  importSuccess: "{count} facteurs importés avec succès",
  clearInvalidSuccess: "{count} lignes de données non valides effacées",
  noInvalidData: "Aucune donnée non valide à effacer",
  uploadText: "Cliquez ou faites glisser le fichier vers cette zone pour le télécharger",
  uploadHint: "Prend en charge les formats CSV et XLSX",
  unitRequired: "Veuillez sélectionner une unité",
  unitInvalid: "Unité invalide, seuls kg CO2e/kg ou kg CO2e/tonne sont pris en charge",
  batchDelete: "Suppression groupée",
  batchDeleteSuccess: "{count} facteurs supprimés avec succès",
  batchDeleteError: "Échec de la suppression groupée des facteurs",
};
